import React, { useState, useEffect } from 'react';
import { Button, Input, Label, UncontrolledAlert } from "reactstrap";
import Cookies from 'js-cookie';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
const data = [
  { title: 'Noodzakelijke cookies', desc: `We plaatsen functionele cookies om ervoor te zorgen dat de basisfuncties van onze website goed werken. Functionele cookies zorgen ervoor dat u de website op de juiste manier kunt bekijken en gebruiken. Deze cookies hebben nagenoeg geen invloed op uw privacy en daarom plaatsen we ze altijd.` },
  { title: 'Analytische cookies', desc: 'Analytische cookies zoals Google Analytics en Google Tag Manager houden websitebezoeken bij en helpen ons de website te verbeteren. Deze gegevens worden anoniem verzameld en hebben minimale consequenties op uw privacy.' },
  { title: 'Marketing cookies', desc: 'Marketing cookies worden gebruikt om te zien hoe de website wordt gebruikt. Hiermee wordt bepaald welke advertenties of socials je te zien krijgt. Deze cookies volgen bezoekers op verschillende websites en verzamelen informatie om op maat gemaakte advertenties aan te bieden.' }
]
const Popup = () => {
  const [isCookieAccepted, setIsCookieAccepted] = useState(Cookies.get('werkenInDe-cookieAccepted'));
  const [isSetting, setIsSetting] = useState(false);
  const [isSelected, setIsSelected] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const handleAcceptCookie = () => {
    Cookies.set('werkenInDe-cookieAccepted', 'true', { expires: 365 }); // Set cookie to be valid for 1 year
    setIsCookieAccepted(true);
  };
  const toggleAlert = () => {
    Cookies.set('werkenInDe-cookieAccepted', 'false', { expires: 365 }); // Set cookie to be valid for 1 year
    setIsCookieAccepted(true);
  };
  const { t } = useTranslation()
  useEffect(() => {
    if (!isCookieAccepted) {
    }
  }, [isCookieAccepted]);

  if (isCookieAccepted) {
    return null; // If the cookie is accepted, don't render the popup
  }

  return (
    <React.Fragment>
      <UncontrolledAlert className="card w-100 cookie-popup bg-white shadow rounded py-3 px-4">
        <Button color="warning" className="btn btn-close bg-transparent" onClick={toggleAlert} />
        <h6>{isSetting ? "Cookie instellingen" : "Wij gebruiken cookies"}</h6>
        {isSetting ? <div>
          {isSelected ? <p className="text-muted mb-0 fs_09" > {selectedRow?.desc} </p> :
            <ul style={{ listStyle: 'none' }}>
              {data?.map((item, index) => (
                <li key={index}>
                  <div className='d-flex w-100' >
                    <Input
                      type='checkbox'
                      className=''
                      defaultChecked={index === 0 || index === 1}
                      disabled={index === 0}
                    />
                    <Label className='ms-2 d-flex align-items-center  gap-1 w-100' >
                      <div className='w-100 underline' onClick={() => {
                        setIsSelected(true)
                        setSelectedRow(item)
                      }} style={{ maxWidth: '10rem', cursor: 'pointer' }} > {item.title} </div>  <hr className='m-0 w-100 ' /> {index === 0 && <div>Vereist</div>}
                    </Label>
                  </div>
                </li>
              ))}
            </ul>}
        </div> :
          <p className="text-muted mb-0 fs_09">
            We plaatsen functionele cookies om ervoor te zorgen dat de basisfuncties van onze website goed werken. Functionele cookies zorgen ervoor dat u de website op de juiste manier kunt bekijken en gebruiken. Deze cookies hebben nagenoeg geen invloed op uw <Link to={'/privacy-cookies'} target='_blank' className='fw-bold underline text-black' >privacy</Link> en daarom plaatsen we ze altijd.
          </p>}
        <div className='d-flex gap-3 flex-wrap justify-content-sm-start justify-content-center mt-2' >
          {isSelected ? <button onClick={() => {
            setIsSelected(false)
            setSelectedRow(null)
          }} className="btn btn-success">
            {t('home_popup_btn4')}
          </button> :
            <button onClick={handleAcceptCookie} className="btn btn-success">
              {!isSetting ? t('home_popup_btn') : t('home_popup_btn3')}
            </button>}
          {!isSetting &&
            <button onClick={() => setIsSetting(true)} className="btn btn-soft-dark">
              {t('home_popup_btn2')}
            </button>}
        </div>
      </UncontrolledAlert>
    </React.Fragment>
  );
};

export default Popup;
